import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { VenueService } from "../../../services/venues/venue.service";
import { DropdownHelperModel } from "../../../models/helpers/dropdown-helper.model";
import { Subject, takeUntil } from "rxjs";
import { MessageService } from "primeng/api";
import { AssignVenuesEmployeeModel } from "../../../models/employees/assign-venues-employee.model";
import { EmployeeService } from "../../../services/employees/employe.service";
import { EmployeeModel } from "../../../models/employees/employee.model";

@Component({
  selector: 'app-assign-venues',
  templateUrl: './assign-venues.component.html',
  styleUrls: ['./assign-venues.component.scss']
})
export class AssignVenuesComponent implements OnInit {

  //#region Fields
  public listAllVenues: Array<DropdownHelperModel> = new Array<DropdownHelperModel> ();
  public selectedVenues: Array<string> = new Array<string> ();
  public employeeId: string;
  public unsubscribe: Subject<void> = new Subject<void>();
  public assignVenuesModel: AssignVenuesEmployeeModel = new AssignVenuesEmployeeModel();
  public spinner: boolean = false;
  //#endregion

  //#region Constructor
  constructor(private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              private venueService: VenueService,
              private employeeService: EmployeeService,
              private messageService: MessageService) {

    if (this.config.data != undefined && this.config.data.id) {
      this.employeeId = this.config.data.id;
    }
  }

  ngOnInit(): void {
    this.getAllVenues();
  }

  //#endregion

  //#region Public Methods
  assignVenues(employeeId: string, venueIds: string[]) {
    this.assignVenuesModel.employeeId = employeeId;
    this.assignVenuesModel.venueIds = venueIds;

    this.spinner = true;
    this.employeeService.addEmployeeToVenues(this.assignVenuesModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  getAllVenues() {
    this.spinner = true;
    this.listAllVenues = new Array<DropdownHelperModel>();

    this.venueService.listallgmnvenuesforcombo()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.listAllVenues = response;
          this.getAllEmployeesForVenues(response);
          this.spinner = false;
        },
        error: errorResponse => {
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
          this.spinner = false;
        }
      });
  }

  getAllEmployeesForVenues(employeesPerVenue: Array<EmployeeModel>): void {
    let venues: string[] = [];
    employeesPerVenue.forEach(venue => {
      this.employeeService.listAllEmployeesForVenue(venue.id.toString())
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            if (response.map((x: EmployeeModel) => x.id).includes(this.employeeId)) {
              venues.push(venue.id.toString());
            }
            this.selectedVenues = [...venues];
          }
        });
    });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
